<template>
  <div class="column items-center">
    <q-spinner :size="size" color="primary" />
    <span
      :style="{
        fontSize: textSize,
      }"
      class="text-primary q-mt-sm"
    >
      {{ text }}...
    </span>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "30px",
    },
    textSize: {
      type: String,
      default: "0.8rem",
    },
    text: {
      type: String,
      default: "正在加载"
    }
  },
};
</script>
